import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import ForScreen from '../ForScreen';

import PrimaryButton from '../../Component/PrimaryButton';
import WishInfo from '../../Component/WishInfo';
import ChildInfo from '../../Component/ChildInfo';
import './WishList.scss';

class WishList extends Component {
  renderCheckMark(fulfilled) {
    if (fulfilled) {
      return <i className="fa fa-check wish-list-check-icon" />;
    }
    return null;
  }

  wishBody(wish) {
    return (
      <div className="wish-body text-left">
        <div className="wish-heading">
          {wish.fulfilled ? (
            <h2 className="wish-fulfilled">
              {wish.label} {this.renderCheckMark(wish.fulfilled)}
            </h2>
          ) : (
            <h2 className={wish.fulfilled ? 'wish-fulfilled' : null}>
              <ForScreen desktop>
                <Link to={'/wish/' + wish.id}>
                  {wish.label} {this.renderCheckMark(wish.fulfilled)}
                </Link>
              </ForScreen>
              <ForScreen mobile>
                {wish.label} {this.renderCheckMark(wish.fulfilled)}
              </ForScreen>
            </h2>
          )}
        </div>
        <WishInfo
          amount={wish.amount}
          amountCollected={wish.amountCollected}
          purchase={wish.purchase}
          fulfilled={wish.fulfilled}
        />
        <ForScreen desktop>
          <p>{wish.description}</p>
          <PrimaryButton
            title="SPENDEN"
            to={'/wish/' + wish.id}
            size="md"
            child={wish.child}
            disabled={wish.fulfilled}
            className="hidden-xs"
          />
        </ForScreen>
        <div className="visible-xs">
          {!wish.fulfilled && <i className="far fa-chevron-right" />}
        </div>
      </div>
    );
  }

  wishesListElement(wish, i) {
    return (
      <React.Fragment key={i}>
        <ForScreen desktop>{this.wishBody(wish)}</ForScreen>

        <ForScreen mobile>
          {wish.fulfilled === false ? (
            <Link to={'/wish/' + wish.id}>{this.wishBody(wish)}</Link>
          ) : (
            this.wishBody(wish)
          )}
        </ForScreen>
      </React.Fragment>
    );
  }

  render() {
    const wishes = this.props.wishes;
    if (!wishes) return null;

    let child = this.props.child;

    return (
      <div className="child-wishes">
        <div className="child text-center">
          <ChildInfo child={child} shortViewMode />
        </div>
        <div className="child-wishes-list">
          {wishes.map((wish, i) => this.wishesListElement(wish, i))}
        </div>
      </div>
    );
  }
}

export default WishList;



// WEBPACK FOOTER //
// ./src/Containers/ChildList/WishList.js